module.exports = __webpack_public_path__ + "static/media/MainLogo.65934cb1.svg";